
/**
 * Gets file icon class to use according to given format (extension)
 * @param {string} format
 * @return {String} returns string of icon file format
 */
function getFileIcon (format: string) {
  const iconMap = {
    'fa-file-pdf': ['pdf'],
    'fa-file-powerpoint': ['pptx', 'pptm', 'ppsx', 'ppsm'],
    'fa-file-word': ['docx', 'docm', 'dotx', 'dotm'],
    'fa-file-excel': ['xlsx', 'xlsm', 'xltx', 'xltm'],
    'fa-file-image': ['jpg', 'jpeg', 'png', 'gif', 'tiff'],
    'fa-file-music': ['mp3', 'wav', 'wma', 'aac', 'flac'],
    'fa-file-video': ['mp4', 'avi', 'wmv', 'mov']
  }

  for (const [icon, formats] of Object.entries(iconMap)) {
    if (formats.includes(format)) {
      return icon
    }
  }

  return 'fa-file-document'
}

export { getFileIcon }
